// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TfXO","fullView":"styles_fullView__3vdT5"};